module.exports = __webpack_public_path__ + "static/iphone-fd0f303264561ae5f08c5e96fad77192.png";